// src/components/IdeaMap/HUD.js
import React from "react";
import classes from "./HUD.module.css";
import { db } from "../../../firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { bypassNextConfirm } from "../useConfirmExit";

const HUD = ({ answeredCount, totalNodes, fgRef, graphData, user  }) => {
  const navigate = useNavigate();


    const handleZoomOut = () => {
        console.log(answeredCount);
        if (answeredCount !== 0 ){
            if (fgRef.current) {
                fgRef.current.zoomToFit(1000, 200); 
                // 1000ms animation, 50px padding
                }
        }
  };

  function cleanObject(obj) {
  if (Array.isArray(obj)) {
    return obj.map(cleanObject);
  } else if (obj && typeof obj === "object") {
    const cleaned = {};
    for (const [k, v] of Object.entries(obj)) {
      if (v !== undefined) {
        cleaned[k] = cleanObject(v);
      }
    }
    return cleaned;
  }
  return obj;
}



  const handleSave = async () => {
    if (!user) {
      alert("Please log in to save.");
      return;
    }

    if (answeredCount === 0 ){
        alert("Answer one question to save");
        return;
    }

    try {
        const cleanedGraph = cleanObject(graphData);

      await addDoc(collection(db, "mindmaps"), {
        userId: user.uid,
        title: `Mindmap - ${new Date().toLocaleString()}`,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
        graphData: cleanedGraph
      });

      await addDoc(collection(db, "users", user.uid, "mindmaps"), {
      title: `Mindmap - ${new Date().toLocaleString()}`,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      graphData: cleanedGraph,
    });

      bypassNextConfirm();    // ✅ guarantee next navigate skips confirm
      navigate("/account");
    } catch (err) {
      console.error("Error saving mindmap:", err);
    }
  };

  

  return (
    <div className={classes.hud}>
      {/* <div className={classes.hudBox}>
        <h3>Idea Map HUD</h3>
        <p>Answered: {answeredCount}</p>
        <p>Total Nodes: {totalNodes}</p>
      </div> */}
      <div className={classes.hudActions}>
        <button onClick={handleZoomOut}>Center Map</button>
        <button onClick={handleSave}>Save</button>
      </div>
    </div>
  );
};

export default HUD;
